const IMPORT_STATUS = Object.freeze({
    AVAILABLE: 1,
    UNAVAILABLE: 2,
    INPROGRESS: 3,
    COMPLETED: 4,
    ERROR: 5,
});

module.exports = {
    IMPORT_STATUS
};
